import { clsx } from 'clsx/lite'
import type { ComponentProps, ReactNode } from 'react'
import { Section } from '../elements/section'

export function FeatureThreeColumnWithDemos({
  demo,
  headline,
  subheadline,
  featured = false,
  className,
  ...props
}: {
  demo: ReactNode
  headline: ReactNode
  subheadline: ReactNode
  featured?: boolean
} & ComponentProps<'div'>) {
  return (
    <div
      className={clsx(
        'min-w-0 rounded-lg bg-mauve-950/2.5 p-2 dark:bg-white/5',
        featured && 'lg:flex lg:items-center lg:gap-8 lg:p-4',
        className,
      )}
      {...props}
    >
      <div
        className={clsx(
          'relative overflow-hidden rounded-sm dark:after:absolute dark:after:inset-0 dark:after:rounded-sm dark:after:outline-1 dark:after:-outline-offset-1 dark:after:outline-white/10',
          featured && 'lg:w-1/2 lg:shrink-0',
        )}
      >
        {demo}
      </div>
      <div className={clsx('p-6 sm:p-10 lg:p-6', featured && 'lg:w-1/2 lg:p-4')}>
        <h3 className="text-base/8 font-medium text-mauve-950 dark:text-white">{headline}</h3>
        <div className="mt-2 flex flex-col gap-4 text-sm/7 text-mauve-700 dark:text-mauve-400">{subheadline}</div>
      </div>
    </div>
  )
}

export function Features({
  featured,
  features,
  ...props
}: { featured?: ReactNode; features: ReactNode } & Omit<ComponentProps<typeof Section>, 'children'>) {
  return (
    <Section {...props}>
      <div className="flex min-w-0 flex-col gap-2">
        {featured}
        <div className="grid min-w-0 grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4">{features}</div>
      </div>
    </Section>
  )
}
